import React, { useEffect, useState } from 'react'
import PopupNotification from './/PopupNotification'

import { Form, Select, Button, Space, DatePicker } from 'antd'
import { circularProgressClasses, Stack } from '@mui/material'

// import dayjs from 'dayjs';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  LinearProgress,
  Tooltip
} from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress' // Import Circular Loader

import CloseIcon from '@mui/icons-material/Close'
import LinkIcon from '@mui/icons-material/Link'
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios'
import { useSelector, useDispatch } from 'react-redux'
import { setLoading } from '../store/feedback'
import moment from 'moment'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './createAudit.css'
import data from './data.json'
import { set_audit_details, set_full_audit_details } from '../store/images'
import {
  StyledDatePicker,
  StyledInput,
  StyledSelect
} from '../login-module/customComponents/styled_input'
import { useNavigate, useParams } from 'react-router-dom'
// import TextField, { Input } from '@material/react-text-field';
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import { createTheme, ThemeProvider } from '@mui/material/styles'
const AuditDetails = props => {
  const theme = createTheme({
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontSize: '16px'
          }
        }
      }
    }
  })

  const navigate = useNavigate()
  const { audit_id } = useParams()
  const [userId, setUserId] = useState(null)
  const [isCopied, setIsCopied] = useState(false)
  const [reqUrl, setReqUrl] = useState(null)
  const [dialogSeverity, setDialogSeverity] = useState('success')
  const [openDialog, setOpenDialog] = useState(false)
  const { user_userID } = useSelector(state => state.imagesStore)

  const dispatch = useDispatch()
  const [selectedMake, setSelectedMake] = useState(null)
  const [selectedModel, setSelectedModel] = useState(null)
  const [popupVisible, setPopupVisible] = useState(false)
  const [popupMessage, setPopupMessage] = useState('')

  const [models, setModels] = useState([])
  const [variants, setVariants] = useState([])
  const share = `${process.env.PUBLIC_URL}/custom-icons/share.svg`
  const [auditDetails, setAuditDetails] = useState({})
  const [updatedData, setUpdatedData] = useState({
    'Year of Manufacturing': null,
    'Registration Date': null
  })
  const [date, setDate] = useState(null)
  const [formattedDate, setFormattedDate] = useState('')
  const [yearOfManufacturing, setYearOfManufacturing] = useState(null) // State to store the selected Year of Manufacturing
  const [searchValue, setSearchValue] = useState('') // To track user input

  const filteredOptions = data
    .map(item => item.make)
    .filter(make => make.toLowerCase().includes(searchValue.toLowerCase())) // Filter based on input
    .sort()
    .map(make => ({ value: make, label: make })) // Map to StyledSelect format

  // Handle change for Year of Manufacturing
  const handleYearOfManufacturingChange = (date, dateString) => {
    setYearOfManufacturing(date) // Store the selected year in state
    form.setFieldsValue({ [date]: dateString })
    onChangeDateTime('Year of Manufacturing', date, dateString)
  }

  // const disabledRegistrationDate = current => {
  //   if (!yearOfManufacturing) {
  //     return false;
  //   }
  //   return current && current.year() < yearOfManufacturing.year();
  // };
  const disabledRegistrationDate = current => {
    const today = new Date()
    if (!yearOfManufacturing) {
      // If year of manufacturing is not set, only ensure the date is not in the future
      return current && current > today
    }
    return (
      current &&
      (current < yearOfManufacturing.startOf('year') || current > today)
    )
  }
  const onChangeDateTime = (type, date, dateString) => {
    console.log(dateString, type)
    form.setFieldsValue({ [type]: dateString })
    // dispatch(set_audit_details({ type, value: dateString }));
    setAuditDetails(prevDetails => ({
      ...prevDetails,
      [type]: dateString
    }))
  }

  const handleMakeChange = (type, value) => {
    // form.setFieldsValue({ 'Model Name': null, 'Variant Name': null });
    form.setFieldsValue({
      ['Make']: value,
      ['Model Name']: value,
      ['Variant Name']: value
    })
    setSelectedMake(value)
    setSelectedModel(null) // Reset selected model
    setVariants([]) // Reset variants
    const makeData = data.find(item => item.make === value)
    setModels(makeData ? makeData.models : [])
    console.log('99', makeData)

    // dispatch(set_audit_details({ type, value }));
    setAuditDetails(prevDetails => ({
      ...prevDetails,
      [type]: value
    }))
  }
  console.log(auditDetails, '46')
  const handleModelChange = (type, value) => {
    // console.log("109",type, value,value.value);
    setSelectedModel(value)
    if (type === 'Model') {
      console.log(type, '50')
      // form.setFieldsValue({ [type]: value });
      const modelData = models.find(item => item.model_name === value.value)
      setVariants(modelData ? modelData.variants : [])
    }
    // dispatch(set_audit_details({ type, value }));
    setAuditDetails(prevDetails => ({
      ...prevDetails,
      [type]: value.value
    }))
  }

  const [dialogWidth, setDialogWidth] = useState('29vw')
  const [dialogText, setDialogText] = useState('0.9rem')

  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth
      if (windowWidth <= 450) {
        setDialogWidth('94vw')
      } else if (windowWidth <= 475) {
        setDialogWidth('94vw')
      } else if (windowWidth <= 570) {
      } else if (windowWidth <= 575) {
        setDialogText('0.6rem')
        setDialogWidth('64vw')
      } else if (windowWidth <= 650) {
        setDialogWidth('60vw')
      } else if (windowWidth <= 700) {
      } else if (window.innerWidth <= 775) {
        setDialogWidth('57vw')
      } else if (window.innerWidth <= 875) {
        setDialogWidth('55vw')
      } else if (windowWidth <= 1000) {
        setDialogWidth('48vw')
      } else if (window.innerWidth <= 1100) {
        setDialogWidth('45vw')
        setDialogText('0.8rem')
      } else if (windowWidth <= 1300) {
        setDialogWidth('40vw')
      } else {
        setDialogWidth('35vw')
      }
    }

    window.addEventListener('resize', handleResize)

    handleResize()

    // Cleanup function to remove event listener
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const generateRandomNDigitString = n => {
    const uuid = uuidv4().replace(/-/g, '')
    const randomString = uuid.substring(0, n)
    return randomString
  }

  const handleCopy = () => {
    setIsCopied(true)
    navigator.clipboard
      .writeText(reqUrl)
      .then(() => {
        setIsCopied(true)
        toast.success('Link Copied!', {
          position: 'bottom-center',
          autoClose: 1000,
          type: 'default',
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          className: 'custom-toast'
        })
      })
      .catch(err => {
        console.error('Failed to copy: ', err)
      })
  }

  const generateRandomId = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    let result = ''

    for (let i = 0; i < 4; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length)
      result += characters[randomIndex]
    }

    const now = new Date()
    const year = now.getFullYear().toString().slice(-2) // Last 2 digits of year
    const month = (now.getMonth() + 1).toString().padStart(2, '0') // Month (1-12) padded to 2 digits
    const day = now.getDate().toString().padStart(2, '0') // Day padded to 2 digits
    const hours = now.getHours().toString().padStart(2, '0') // Hours padded to 2 digits
    const mins = now.getMinutes().toString().padStart(2, '0') // Minutes padded to 2 digits

    const secs = now.getSeconds().toString().padStart(2, '0') // Seconds padded to 2 digits

    const dateTimePart = day + hours + mins + secs

    result += dateTimePart
    return result.slice(0, 12)
  }

  const handleInputChange = (type, e) => {
    let value = e.target.value
    if (type === 'Vehicle No') {
      value = e.target.value.toUpperCase()
    }
    console.log('217', type, value)

    // dispatch(set_audit_details({ type, value }));
    setAuditDetails(prevDetails => ({
      ...prevDetails,
      [type]: value
    }))
  }

  const handleSelectionChange = (type, value) => {
    console.log(type, value)
    // dispatch(set_audit_details({ type, value }));
    form.setFieldsValue({ [type]: value })

    setAuditDetails(prevDetails => ({
      ...prevDetails,
      [type]: value
    }))
  }

  useEffect(() => {
    // generating default info
    const uuid = generateRandomNDigitString(10).toUpperCase()
    setUserId(uuid)
  }, [])
  // console.log(updatedData);
  useEffect(() => {
    const cachedCompanies = localStorage.getItem('insuranceUser')
    const company = cachedCompanies ? JSON.parse(cachedCompanies).company : ''
    setAuditDetails(prevDetails => ({
      ...prevDetails,
      'User Id': userId,
      'Insurance Company': company,
      'Name of Customer': '',
      'Vehicle No': '',
      'Client Name': '',
      'Powered By': 'Surveyor AI',
      'Dealer Code': '',
      'Program Name': '',
      'Inspection Date': moment().format('DD-MM-YYYY'),
      'Inspection Time': moment().format('HH:mm'),
      'Client Unique Reference No.':
        generateRandomNDigitString(10).toUpperCase(),
      'PI Type': '',
      'Proposer Type': '',
      'Vehicle Class': '',
      Make: '',
      Model: '',
      Variant: '',
      'Chassis number': '',
      'Engine number': '',
      'Year of Manufacturing': '',
      'Registration Date': '',
      'Report Generate Date & Time': moment(new Date()).format(
        'DD MMM, YYYY hh:mm:ss a'
      )
    }))
  }, [userId])
  const [isFormValid, setIsFormValid] = useState(false)

  const validateForm = () => {
    return Object.values(auditDetails).every(
      value => (value ?? '').toString().trim() !== ''
    )
  }

  useEffect(() => {
    setIsFormValid(validateForm())
  }, [auditDetails])

  const [form] = Form.useForm()

  const showAlert = (severity, message) => {
    setDialogSeverity(severity)
    setOpenDialog(true)
  }

  const handleDialogClose = event => {
    // if (
    //   event.target.tagName.toLowerCase() !== "button" &&
    //   !event.target.closest("button")
    // ) {

    //   return;
    // }
    setOpenDialog(false)
  }

  const insuranceUser = JSON.parse(localStorage.getItem('insuranceUser'))

  const user_Id = insuranceUser?.userId
  console.log('331', user_Id)
  const [loading, setLoadingState] = useState(false)

  const insuranceConfig = JSON.parse(localStorage.getItem('inspectionConfig'))
  console.log('345', insuranceConfig.inspection_config)

  // const onFinish = async (values) => {
  //   const chassisNumber = auditDetails['Chassis number']?.trim() || '';

  //   // Show error using custom popup
  //   const showPopup = (msg) => {
  //     setPopupMessage(msg);
  //     setPopupVisible(true);
  //   };

  //   // Check if empty
  //   if (!chassisNumber) {
  //     showPopup('Please enter the Chassis number');
  //     return;
  //   }

  //   // Check length >= 6
  //   if (chassisNumber.length < 6) {
  //     showPopup('Chassis number must be at least 6 characters long');
  //     return;
  //   }

  //   // Check contains at least one digit and one letter
  //   const hasDigit = /\d/.test(chassisNumber);
  //   const hasLetter = /[a-zA-Z]/.test(chassisNumber);

  //   if (!hasDigit || !hasLetter) {
  //     showPopup('Chassis number must contain both letters and digits');
  //     return;
  //   }

  //   // Passed all validations — proceed with submission
  //   setLoadingState(true);
  //   dispatch(setLoading(true));

  //   const audit = generateRandomId();
  //   const configData = insuranceConfig.inspection_config;
  //   const orgId = insuranceConfig.org_id;

  //   try {
  //     const res = await axios.post('/create_audit/get_token', {
  //       auditID: audit,
  //       lead_creation_time: moment().format('DD-MM-YYYY HH:mm'),
  //       user_ID: user_Id,
  //       configData: configData,
  //       orgId: orgId,
  //     });

  //     const uploadUrl = `https://caiproduction002.blob.core.windows.net/ira/insurance-inspection-details/${audit}.json`;
  //     const sasToken =
  //       '?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2050-05-06T01:59:09Z&st=2022-05-05T17:59:09Z&spr=https&sig=SsFQp5OkIrSG9gVnf4V9F4Vi463mtW25t0Vw2SQzVIM%3D';

  //     const response = await axios.put(
  //       `${uploadUrl}${sasToken}`,
  //       JSON.stringify(auditDetails),
  //       {
  //         headers: {
  //           'x-ms-blob-type': 'BlockBlob',
  //           'Content-Type': 'application/json',
  //         },
  //       }
  //     );

  //     console.log('Upload successful:', response);
  //     navigate(`/audit/inspection/${audit}`);
  //   } catch (err) {
  //     console.error('Submission error:', err);
  //     showPopup('Something went wrong while submitting. Please try again.');
  //   } finally {
  //     setLoadingState(false);
  //     dispatch(setLoading(false));
  //   }
  // };

  // const onFinish = async (values) => {
  //   const chassisNumber = auditDetails['Chassis number']?.trim() || '';

  //   // Custom popup for errors
  //   const showPopup = (msg) => {
  //     setPopupMessage(msg);
  //     setPopupVisible(true);
  //   };

  //   // ✅ Validation checks
  //   if (!chassisNumber) {
  //     showPopup('Please enter the Chassis number');
  //     return;
  //   }

  //   if (chassisNumber.length < 6) {
  //     showPopup('Chassis number must be at least 6 characters long');
  //     return;
  //   }

  //   const hasDigit = /\d/.test(chassisNumber);
  //   const hasLetter = /[a-zA-Z]/.test(chassisNumber);

  //   if (!hasDigit || !hasLetter) {
  //     showPopup('Chassis number must contain both letters and digits');
  //     return;
  //   }

  //   // ✅ Passed all validations — proceed with submission
  //   setLoadingState(true);
  //   dispatch(setLoading(true));

  //   const audit = generateRandomId();
  //   const configData = insuranceConfig.inspection_config;
  //   const orgId = insuranceConfig.org_id;

  //   try {
  //     // ✅ Step 1: Create audit and get token
  //     await axios.post('/create_audit/get_token', {
  //       auditID: audit,
  //       lead_creation_time: moment().format('DD-MM-YYYY HH:mm'),
  //       user_ID: user_Id,
  //       configData: configData,
  //       orgId: orgId,
  //     });

  //     // ✅ Step 2: Prepare data for S3 upload
  //     const blobName = `Insurance_Inspection_Details/${audit}.json`;
  //     const fileContent = btoa(JSON.stringify(auditDetails)); // Convert JSON to Base64
  //     const contentType = 'application/json';

  //     // ✅ Step 3: Upload to S3 via backend API
  //     const uploadResponse = await axios.post('/process_data/upload-file-others', {
  //       blobName,
  //       fileContent,
  //       contentType,
  //     });

  //     console.log('Upload successful:', uploadResponse.data);

  //     // ✅ Step 4: Navigate to next page
  //     navigate(`/audit/inspection/${audit}`);
  //   } catch (err) {
  //     console.error('Submission error:', err);
  //     showPopup('Something went wrong while submitting. Please try again.');
  //   } finally {
  //     setLoadingState(false);
  //     dispatch(setLoading(false));
  //   }
  // };

  const onFinish = async values => {
    const chassisNumber = auditDetails['Chassis number']?.trim() || ''

    // Custom popup for errors
    const showPopup = msg => {
      setPopupMessage(msg)
      setPopupVisible(true)
    }

    // ✅ Validation checks
    if (!chassisNumber) {
      showPopup('Please enter the Chassis number')
      return
    }

    if (chassisNumber.length < 6) {
      showPopup('Chassis number must be at least 6 characters long')
      return
    }

    const hasDigit = /\d/.test(chassisNumber)
    const hasLetter = /[a-zA-Z]/.test(chassisNumber)

    if (!hasDigit || !hasLetter) {
      showPopup('Chassis number must contain both letters and digits')
      return
    }

    // ✅ Passed all validations — proceed with submission
    setLoadingState(true)
    dispatch(setLoading(true))

    const audit = generateRandomId()
    const configData = insuranceConfig.inspection_config
    const orgId = insuranceConfig.org_id

    try {
      // ✅ Step 1: Fetch program info based on orgId
      const programResponse = await axios.post('/create_audit/getProgramByOrgId', { orgId })
      if (!programResponse.data || programResponse.data.length === 0) {
        showPopup('No program found for this organization.')
        setLoadingState(false)
        dispatch(setLoading(false))
        return
      }

      // Assuming backend returns: { program_id, program_name }
      const { program_id, prog_name } = programResponse.data
	  console.log("546",program_id,prog_name);
	  
      // ✅ Step 2: Create audit and get token
      await axios.post('/create_audit/get_token', {
        auditID: audit,
        lead_creation_time: moment().format('DD-MM-YYYY HH:mm'),
        user_ID: user_Id,
        configData: configData,
        orgId: orgId,
        program_id: program_id,
        program_name: prog_name
      })

      // ✅ Step 3: Prepare data for S3 upload
      const blobName = `Insurance_Inspection_Details/${audit}.json`
      const fileContent = btoa(JSON.stringify(auditDetails)) // Convert JSON to Base64
      const contentType = 'application/json'

      // ✅ Step 4: Upload to S3 via backend API
      const uploadResponse = await axios.post(
        '/process_data/upload-file-others',
        {
          blobName,
          fileContent,
          contentType
        }
      )

      console.log('Upload successful:', uploadResponse.data)

      // ✅ Step 5: Navigate to next page
      navigate(`/audit/inspection/${audit}`)
    } catch (err) {
      console.error('Submission error:', err)
      showPopup('Something went wrong while submitting. Please try again.')
    } finally {
      setLoadingState(false)
      dispatch(setLoading(false))
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: '10px'
        }}
      >
        <style jsx>
          {`
            .input-lowercase::placeholder {
              text-transform: capitalize;
            }
          `}
        </style>

        <div
          className='responsive-form-container'
          style={{
            flex: 1,
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px'
          }}
        >
          {loading && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.3)', // Dark overlay effect
                zIndex: 10,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <CircularProgress size={40} sx={{ color: '#ff0083' }} />
            </div>
          )}
          <PopupNotification
            visible={popupVisible}
            message={popupMessage}
            onClose={() => setPopupVisible(false)}
          />

          <div className='form-data'>
            <div className='audit-details-group' style={{ width: '80vw' }}>
              <div className='input-wrapper'>
                <Form.Item
                  name='Insurance Company'
                  style={{ position: 'relative' }}
                  rules={[
                    {
                      required: true,
                      message: 'Insurance company is required'
                    }
                  ]}
                >
                  <div style={{ position: 'relative' }}>
                    <StyledSelect
                      value={auditDetails['Insurance Company']}
                      style={{ width: 200 }}
                      disabled
                    />
                    <span className='fill'>Insurance Company</span>
                  </div>
                </Form.Item>
              </div>

              {/* Name of Customer */}
              <div className='input-wrapper'>
                <Form.Item
                  name='Name of Customer'
                  rules={[
                    {
                      required: true,
                      message: 'Please enter the Customer Name'
                    }
                  ]}
                >
                  <div style={{ position: 'relative' }}>
                    <StyledInput
                      value={auditDetails['Name of Customer']}
                      style={{ width: 200 }}
                      placeholder=' '
                      onChange={e => handleInputChange('Name of Customer', e)}
                    />
                    <span
                      className={
                        auditDetails['Name of Customer'] ? 'fill' : 'unfilled'
                      }
                    >
                      Name of Customer
                    </span>
                  </div>
                </Form.Item>
              </div>

              {/* Vehicle No. */}
              <div className='input-wrapper'>
                <Form.Item
                  name='Enter Vehicle No.'
                  rules={[
                    { required: true, message: 'Please enter the Vehicle No.' }
                  ]}
                >
                  <div style={{ position: 'relative' }}>
                    <StyledInput
                      value={auditDetails['Vehicle No']}
                      className='input-lowercase'
                      placeholder=' '
                      style={{ width: 200, textTransform: 'uppercase' }}
                      onChange={e => handleInputChange('Vehicle No', e)}
                    />
                    <span
                      className={
                        auditDetails['Vehicle No'] ? 'fill' : 'unfilled'
                      }
                    >
                      Vehicle No.
                    </span>
                  </div>
                </Form.Item>
              </div>

              {/* Client Name */}
              <div className='input-wrapper'>
                <Form.Item
                  name='Name of Client'
                  rules={[
                    { required: true, message: 'Please enter the Client Name' }
                  ]}
                >
                  <div style={{ position: 'relative' }}>
                    <StyledInput
                      value={auditDetails['Client Name']}
                      style={{ width: 200 }}
                      placeholder=' '
                      onChange={e => handleInputChange('Client Name', e)}
                    />
                    <span
                      className={
                        auditDetails['Client Name'] ? 'fill' : 'unfilled'
                      }
                    >
                      Client Name
                    </span>
                  </div>
                </Form.Item>
              </div>

              {/* Dealer Code */}
              <div className='input-wrapper'>
                <Form.Item
                  name='Dealer Code'
                  rules={[
                    { required: true, message: 'Please select the Dealer Code' }
                  ]}
                >
                  <div style={{ position: 'relative' }}>
                    <StyledSelect
                      value={auditDetails['Dealer Code']}
                      style={{ width: 200 }}
                      // placeholder="Dealer Code"
                      onChange={e => handleSelectionChange('Dealer Code', e)}
                      options={[{ value: 'AFA764FA00', label: 'AFA764FA00' }]}
                    />
                    <span
                      className={
                        auditDetails['Dealer Code'] ? 'fill' : 'unfilled'
                      }
                    >
                      Dealer Code
                    </span>
                  </div>
                </Form.Item>
              </div>

              {/* Program Name */}
              <div className='input-wrapper'>
                <Form.Item
                  name='Program Name'
                  rules={[
                    { required: true, message: 'Please enter the Program Name' }
                  ]}
                >
                  <div style={{ position: 'relative' }}>
                    <StyledInput
                      value={auditDetails['Program Name']}
                      style={{ width: 200 }}
                      placeholder=' '
                      onChange={e => handleInputChange('Program Name', e)}
                    />
                    <span
                      className={
                        auditDetails['Program Name'] ? 'fill' : 'unfilled'
                      }
                    >
                      Program Name
                    </span>
                  </div>
                </Form.Item>
              </div>

              <div className='input-wrapper'>
                <Form.Item
                  name='PI Type'
                  style={{ position: 'relative' }} // Add position relative
                  rules={[
                    { required: true, message: 'Please select the PI Type' }
                  ]}
                >
                  <div style={{ position: 'relative' }}>
                    <StyledSelect
                      value={auditDetails['PI Type']}
                      style={{ width: 200 }}
                      placeholder=' ' // Placeholder to avoid overlap with the label
                      onChange={e => handleSelectionChange('PI Type', e)}
                      options={[
                        { value: 'Add on', label: 'Add on' },
                        {
                          value: 'Addition of Bi-fuel Kit',
                          label: 'Addition of Bi-fuel Kit'
                        },
                        {
                          value: 'Addition of Accessories',
                          label: 'Addition of Accessories'
                        },
                        { value: 'Break In', label: 'Break In' },
                        {
                          value: 'Change in Product',
                          label: 'Change in Product'
                        },
                        { value: 'Cheque Bounce', label: 'Cheque Bounce' },
                        {
                          value: 'NCB Falsification',
                          label: 'NCB Falsification'
                        },
                        {
                          value: 'Old Manufacturing',
                          label: 'Old Manufacturing'
                        },
                        { value: 'Rollover', label: 'Rollover' },
                        {
                          value: 'Substitution of vehicle',
                          label: 'Substitution of vehicle'
                        },
                        {
                          value: 'TP to Comprehensive',
                          label: 'TP to Comprehensive'
                        },
                        {
                          value: 'Transfer of Ownership',
                          label: 'Transfer of Ownership'
                        },
                        { value: 'Used Vehicle', label: 'Used Vehicle' },
                        { value: 'Valuation', label: 'Valuation' }
                      ]}
                    />
                    <span
                      className={auditDetails['PI Type'] ? 'fill' : 'unfilled'}
                    >
                      PI Type
                    </span>
                  </div>
                </Form.Item>
              </div>

              <div className='input-wrapper'>
                <Form.Item
                  name='Proposer Type'
                  style={{ position: 'relative' }} // Add position relative
                  rules={[
                    {
                      required: true,
                      message: 'Please select the Proposer Type'
                    }
                  ]}
                >
                  <div style={{ position: 'relative' }}>
                    <StyledSelect
                      value={auditDetails['Proposer Type']}
                      style={{ width: 200 }}
                      placeholder=' ' // Placeholder to avoid overlap with the label
                      onChange={e => handleSelectionChange('Proposer Type', e)}
                      options={[
                        { value: 'Individual', label: 'Individual' },
                        { value: 'Corporate', label: 'Corporate' }
                      ]}
                    />
                    <span
                      className={
                        auditDetails['Proposer Type'] ? 'fill' : 'unfilled'
                      }
                    >
                      Proposer Type
                    </span>
                  </div>
                </Form.Item>
              </div>

              <div className='input-wrapper'>
                <Form.Item
                  name='Vehicle Class'
                  rules={[
                    {
                      required: true,
                      message: 'Please select the Vehicle Class'
                    }
                  ]}
                  style={{ position: 'relative' }} // Ensure the container has a position
                >
                  <div style={{ position: 'relative' }}>
                    <StyledSelect
                      style={{ width: 200 }}
                      value={auditDetails['Vehicle Class']}
                      // placeholder="Vehicle Class"
                      onChange={e => handleSelectionChange('Vehicle Class', e)}
                      options={[{ value: 'Private', label: 'Private' }]}
                    />
                    <span
                      className={
                        auditDetails['Vehicle Class'] ? 'fill' : 'unfilled'
                      }
                    >
                      Vehicle Class
                    </span>
                  </div>
                </Form.Item>
              </div>

              <div className='input-wrapper' style={{ padding: '5px' }}>
                <Autocomplete
                  options={data.map(item => item.make).sort()} // Dropdown options
                  value={auditDetails['Make'] || ''}
                  onChange={(event, newValue) => {
                    handleMakeChange('Make', newValue || '') // Handle null when cleared
                    handleModelChange('Model', '') // Reset dependent field
                    handleModelChange('Variant', '') // Reset dependent field
                  }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label='Make'
                      variant='outlined'
                      fullWidth
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          padding: '3px 3px', // Reduce the input padding
                          fontSize: '14px'
                        },
                        '& .MuiOutlinedInput-root': {
                          padding: 0,
                          '&.Mui-focused fieldset': {
                            borderColor: 'pink' // Change border color on focus
                          }
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                          color: 'black' // Change label color on focus
                        },
                        '& .MuiInputLabel-root': {
                          top: '-6px', // Adjust label position
                          color: 'rgb(209, 207, 207)',
                          fontSize: '14px'
                        },
                        '& .MuiInputLabel-shrink': {
                          top: '0px',
                          color: 'black'
                        }
                      }}
                    />
                  )}
                  sx={{
                    width: { xs: '100%', sm: '200px' } // Responsive width
                  }}
                />
              </div>

              <div className='input-wrapper' style={{ padding: '5px' }}>
                <Autocomplete
                  options={models
                    .map(model => model.model_name)
                    .sort()
                    .map(model => ({ value: model, label: model }))}
                  value={auditDetails['Model'] || ''}
                  onChange={(event, newValue) => {
                    handleModelChange('Model', newValue || '') // Handle null when cleared
                    // handleModelChange('Variant', ''); // Reset dependent field
                  }}
                  disabled={!selectedMake} // Disable if no make is selected
                  renderInput={params => (
                    <TextField
                      {...params}
                      label='Model'
                      variant='outlined'
                      fullWidth
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          padding: '3px 3px', // Reduce the input padding
                          fontSize: '14px'
                        },
                        '& .MuiOutlinedInput-root': {
                          padding: 0,
                          '&.Mui-focused fieldset': {
                            borderColor: 'pink' // Change border color on focus
                          }
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                          color: 'black' // Change label color on focus
                        },
                        '& .MuiInputLabel-root': {
                          top: '-6px', // Adjust label position
                          color: 'rgb(209, 207, 207)',
                          fontSize: '14px'
                        },
                        '& .MuiInputLabel-shrink': {
                          top: '0px', // Adjust label position when focused
                          color: 'black'
                        }
                      }}
                    />
                  )}
                  sx={{
                    width: { xs: '100%', sm: '200px' } // Responsive width
                  }}
                />
              </div>

              <div className='input-wrapper' style={{ padding: '5px' }}>
                <Autocomplete
                  options={variants
                    .map(variant => variant.variant_name)
                    .sort()
                    .map(variant => ({ value: variant, label: variant }))}
                  value={auditDetails['Variant'] || ''}
                  onChange={(event, newValue) => {
                    handleModelChange('Variant', newValue || '') // Handle null when cleared
                  }}
                  disabled={!selectedModel}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label='Variant'
                      variant='outlined'
                      fullWidth
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          padding: '3px 3px', // Reduce the input padding
                          fontSize: '14px'
                        },
                        '& .MuiOutlinedInput-root': {
                          padding: 0,
                          '&.Mui-focused fieldset': {
                            borderColor: 'pink' // Change border color on focus
                          }
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                          color: 'black' // Change label color on focus
                        },
                        '& .MuiInputLabel-root': {
                          top: '-6px', // Adjust label position
                          color: 'rgb(209, 207, 207)',
                          fontSize: '14px'
                        },
                        '& .MuiInputLabel-shrink': {
                          top: '0px', // Adjust label position when focused
                          color: 'black'
                        }
                      }}
                    />
                  )}
                  sx={{
                    width: { xs: '100%', sm: '200px' } // Responsive width
                  }}
                />
              </div>

              {/* Chassis Number */}
              <div className='input-wrapper'>
                <Form.Item label='' required>
                  <div style={{ position: 'relative' }}>
                    <StyledInput
                      value={auditDetails['Chassis number']}
                      style={{ width: 200 }}
                      placeholder=' '
                      onChange={e => handleInputChange('Chassis number', e)}
                    />
                    <span
                      className={
                        auditDetails['Chassis number'] ? 'fill' : 'unfilled'
                      }
                    >
                      Chassis number
                    </span>
                  </div>
                </Form.Item>
              </div>

              {/* Engine Number */}
              <div className='input-wrapper'>
                <Form.Item
                  name='Engine number'
                  rules={[
                    {
                      required: true,
                      message: 'Please enter the Engine number'
                    }
                  ]}
                >
                  <div style={{ position: 'relative' }}>
                    <StyledInput
                      value={auditDetails['Engine number']}
                      style={{ width: 200 }}
                      placeholder=' '
                      onChange={e => handleInputChange('Engine number', e)}
                    />
                    <span
                      className={
                        auditDetails['Engine number'] ? 'fill' : 'unfilled'
                      }
                    >
                      Engine number
                    </span>
                  </div>
                </Form.Item>
              </div>

              <div className='input-wrapper'>
                <Form.Item
                  name='Year of Manufacturing'
                  rules={[
                    {
                      required: true,
                      message: 'Please select the Year of Manufacturing'
                    }
                  ]}
                >
                  <div style={{ position: 'relative' }}>
                    <StyledDatePicker
                      picker='year'
                      inputReadOnly
                      onChange={handleYearOfManufacturingChange}
                      placeholder=' '
                      disabledDate={current => {
                        // Disable years greater than the current year
                        return (
                          current && current.year() > new Date().getFullYear()
                        )
                      }}
                    />
                    <span
                      className={
                        auditDetails['Year of Manufacturing']
                          ? 'fill'
                          : 'unfilled'
                      }
                    >
                      Year of Manufacturing
                    </span>
                  </div>
                </Form.Item>
              </div>
              <div className='input-wrapper'>
                <Form.Item
                  name='Registration Date'
                  rules={[
                    {
                      required: true,
                      message: 'Please select the Registration Date'
                    }
                  ]}
                >
                  <div style={{ position: 'relative' }}>
                    <StyledDatePicker
                      format='DD-MM-YYYY'
                      inputReadOnly
                      onChange={(date, dateString) =>
                        onChangeDateTime('Registration Date', date, dateString)
                      }
                      placeholder=' '
                      disabled={!yearOfManufacturing}
                      disabledDate={disabledRegistrationDate}
                    />
                    <span
                      className={
                        auditDetails['Registration Date'] ? 'fill' : 'unfilled'
                      }
                    >
                      Registration Date
                    </span>
                  </div>
                </Form.Item>
              </div>
            </div>

            <div
              style={{
                position: 'sticky',
                bottom: 30,
                padding: '16px',
                textAlign: 'center'
              }}
            >
              <Form.Item style={{ margin: '0px' }}>
                <Button
                  style={{
                    backgroundColor: isFormValid ? '#FF0083' : 'gray',
                    // backgroundColor: '#FF0083',
                    color: '#FFFFFF',
                    minHeight: '40px',
                    width: '300px',
                    borderRadius: '2px'
                  }}
                  htmlType='submit'
                  className='responsive-button'
                  disabled={!isFormValid}
                  onClick={onFinish}
                >
                  Submit
                </Button>
              </Form.Item>
            </div>
          </div>
        </div>

        <div style={{ position: 'relative' }}>
          <ToastContainer />
          <Dialog
            open={openDialog}
            onClose={handleDialogClose}
            maxWidth='150vw'
            maxHeight='lg'
            PaperProps={{
              style: {
                width: dialogWidth,
                padding: '1.5rem 1rem',
                paddingBottom: '0.5rem',
                borderRadius: '4px',
                margin: '0px',
                height: '265px',
                zIndex: '999999'
              }
            }}
          >
            <DialogTitle
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                gap: '1rem',
                fontSize: '1.7rem',
                textAlign: 'center',
                color: 'black',
                padding: '2rem 0.6rem 1rem 0.6rem',
                fontWeight: '600',
                fontFamily: 'Barlow Condensed'
              }}
            >
              {dialogSeverity === 'success'
                ? 'Audit created successfully'
                : 'Error'}
              <button
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.2rem',
                  border: '1.5px solid #FF0083',
                  padding: '0.2rem 1.2rem',
                  backgroundColor: 'white',
                  borderRadius: '5px',
                  width: '100%',
                  cursor: 'pointer'
                }}
                onClick={handleCopy}
              >
                <img
                  src={share}
                  style={{ width: '1rem', height: '1rem' }}
                  alt='Share Icon'
                />
                <p
                  style={{
                    fontSize: '1rem',
                    fontFamily: "'Montserrat', sans-serif",
                    color: '#FF0083',
                    padding: '0.5rem',
                    cursor: 'pointer'
                  }}
                >
                  Copy Link
                </p>
              </button>
            </DialogTitle>
            <IconButton
              aria-label='close'
              onClick={handleDialogClose}
              sx={{
                position: 'absolute',
                right: 14,
                top: 30,
                color: 'black'
              }}
            >
              <CloseIcon />
            </IconButton>

            <div style={{ padding: '1rem 0.5rem 0.1rem' }}>
              <p
                style={{
                  color: '#FF0083',
                  textDecoration: 'underline',
                  fontFamily: "'Montserrat', sans-serif",
                  marginBottom: '2px',
                  wordBreak: 'break-word',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  cursor: 'pointer'
                }}
                onClick={() => window.open(reqUrl, '_blank')}
              >
                {reqUrl}
              </p>
            </div>

            <DialogContent style={{ padding: '0.5rem' }}>
              {/* Additional content can go here */}
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </ThemeProvider>
  )
}

export default AuditDetails
